// libs
import React, { memo } from "react";
import { css } from "@emotion/core";

// global components
import WithStyles from "shared/components/WithStyles";
import Collapsible from "shared/components/Collapsible";

// styles
const catCss = css`
    margin: 0 10px;
    border-bottom: 1px solid #ccc;
    font-size: 0.86rem;

    &:last-child {
        border-bottom: 0;
    }

    .ct-title {
        height: 45px;
        color: #666;
        font-weight: 600;
        text-transform: uppercase;
        display: flex;
        align-items: center;
    }

    .ct-list {
        padding: 0;
        margin: 0 0 5px 0;
        list-style: none;
    }

    .ct-item {
        padding-bottom: 5px;
    }

    .ct-anc {
        text-decoration: none;
        color: #666;
    }
`;

// defs
interface ICollapsibleCategoryProps extends Footer.Category {
    isExpanded: boolean;
    onExpanded: VoidFunction;
}

function CollapsibleCategory({ title, links, onExpanded, isExpanded }: ICollapsibleCategoryProps) {
    const onChange = (canExpand: boolean) => canExpand && onExpanded();

    return (
        <WithStyles cssProps={catCss}>
            <Collapsible
                header={<div className="ct-title">{title}</div>}
                onChange={onChange}
                isExpanded={isExpanded}
            >
                <ul className="ct-list">
                    {links.map((link, idx) => (
                        <li className="ct-item" key={idx}>
                            <a className="ct-anc" href={link.href}>
                                {link.text}
                            </a>
                        </li>
                    ))}
                </ul>
            </Collapsible>
        </WithStyles>
    );
}

export default memo(CollapsibleCategory);
